import React from "react";
import {useTranslate} from "@tolgee/react";
import {UPGRADE_SUBSCRIPTION_URL} from "../../../config/constants";

const LomavisUpgradeSubscriptionPageLink: React.FC = (

) => {
    const { t } = useTranslate();

    return (
        <div><a href={UPGRADE_SUBSCRIPTION_URL} className={"text-primary fw-bold"}>{t("lomavisCore.upgradePackage")}</a> </div>
    )

};

export default LomavisUpgradeSubscriptionPageLink;